import { FC } from "react";
import { Flex, Box, Button } from "@smile2impress/components/relaunch";
import { Icon, Icons, Heading, Text } from "@smile2impress/components";

import Link from "components/Link";

import { ListItem } from "./ListItem";
import { InfoBannerProps } from "./InfoBanner.types";

export const InfoBanner: FC<InfoBannerProps> = ({ content }) => {
    const {
        title,
        text,
        bg = "base.grey",
        iconColor = "base.bitterSweet",
        extraTitleStyles,
        icon = "InfoOutlineIcon",
        items,
        cta,
    } = content;
    const iconComponent =
        typeof icon === "string" ? Icons[icon as keyof typeof Icons] : icon;

    return (
        <Flex direction="column" px={[0, 0, 4]}>
            <Flex
                direction={["column"]}
                gap={1}
                bgColor={bg}
                borderRadius="sm"
                p={[2, 2, 3]}
            >
                {iconComponent && (
                    <Flex>
                        <Icon
                            w={3}
                            h={3}
                            as={iconComponent}
                            color={iconColor}
                        />
                    </Flex>
                )}
                <Flex direction={["column"]}>
                    <Flex
                        direction={["column", "column", "row"]}
                        justifyContent="space-between"
                        gap={[2, 2, 0]}
                    >
                        <Heading
                            textStyle={"title3"}
                            flexBasis={["100%", "100%", "45%"]}
                            {...extraTitleStyles}
                        >
                            {title}
                        </Heading>
                        {text && (
                            <Text
                                flexBasis={["100%", "100%", "45%"]}
                                textStyle={["body", "body", "body"]}
                                color={["text.baseInverse"]}
                                mb={0}
                                dangerouslySetInnerHTML={{ __html: text }}
                                whiteSpace="pre-wrap"
                            />
                        )}
                        {items && (
                            <Flex
                                direction={["column", "column", "row"]}
                                gap={[3, 3, "132px"]}
                                mt={[0, 0, -50]}
                                flexBasis={["100%", "100%", "45%"]}
                            >
                                {items.map((item, index) => (
                                    <Flex
                                        key={index}
                                        flexBasis={["100%", "100%", "50%"]}
                                    >
                                        <ListItem {...item} />
                                    </Flex>
                                ))}
                            </Flex>
                        )}
                    </Flex>
                    {cta && (
                        <Box mt={3}>
                            <Button as={Link} href={cta.link} width={"100%"}>
                                {cta.text}
                            </Button>
                        </Box>
                    )}
                </Flex>
            </Flex>
        </Flex>
    );
};
